import { useCallback } from "react";
import { config } from "../config";
import { useEventsApi } from "./useEventsApi";
import type {
  ContractRenameApplyResponse,
  ContractRenamePreviewPayload,
  ContractRenamePreviewResponse,
} from "../shared/adminContractRename";

export const useAdminContractRenameApi = () => {
  const { callApi } = useEventsApi();

  const previewContractRename = useCallback(
    async (payload: ContractRenamePreviewPayload): Promise<ContractRenamePreviewResponse> => {
      return callApi(`${config.apiUrl}/api/admin-contract-rename/preview/`, "POST", payload);
    },
    [callApi]
  );

  const applyContractRename = useCallback(
    async (
      payload: ContractRenamePreviewPayload & { preview_token: string; confirm_text: string }
    ): Promise<ContractRenameApplyResponse> => {
      return callApi(`${config.apiUrl}/api/admin-contract-rename/apply/`, "POST", payload);
    },
    [callApi]
  );

  return { previewContractRename, applyContractRename };
};
